import { useState, useEffect } from 'react'

import type { DraftLead } from '../typings'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { toast } from '@sales-center/components'

const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.draftLead.draftLead}/details`

export function useGetDraftLeadOnMount(id?: string | null) {
  const [state, setState] = useState<{
    loading: boolean
    draft?: DraftLead
  }>({ loading: !!id })

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      const response = await get(`${url}/${id}`)

      if (response.ok) {
        const draft = await response.json()
        try {
          draft.initialDraft = JSON.parse(draft.initialDraft)
        } catch (err) {
          draft.initialDraft = undefined
        }

        if (mounted) setState({ draft, loading: false })
      } else {
        if (mounted) {
          toast.error(`Failed to load pending lead ${id}`)
          setState({ loading: false })
        }
      }
    }
    if (!!id) execute()

    return () => {
      mounted = false
    }
  }, [id])

  return [state.loading, state.draft] as const
}
